/** Supported locale codes (ISO 639-1). */
export const SUPPORTED_LOCALES = [
    "en", "ru", "zh", "es", "de", "fr", "hi", "ja", "ko", "id", "vi", "th", "ms", "tl", "it", "pt", "pl", "nl", "uk", "be", "cs", "hu", "ro", "fi", "sv", "da", "no", "el", "sr", "bg"
];

/** i18n key for language name in UI (e.g. "language.english"). */
export const LOCALE_LABEL_KEY_BY_CODE = {
    en: "language.english",
    ru: "language.russian",
    zh: "language.chinese",
    es: "language.spanish",
    de: "language.german",
    fr: "language.french",
    hi: "language.hindi",
    ja: "language.japanese",
    ko: "language.korean",
    id: "language.indonesian",
    vi: "language.vietnamese",
    th: "language.thai",
    ms: "language.malay",
    tl: "language.filipino",
    it: "language.italian",
    pt: "language.portuguese",
    pl: "language.polish",
    nl: "language.dutch",
    uk: "language.ukrainian",
    be: "language.belarusian",
    cs: "language.czech",
    hu: "language.hungarian",
    ro: "language.romanian",
    fi: "language.finnish",
    sv: "language.swedish",
    da: "language.danish",
    no: "language.norwegian",
    el: "language.greek",
    sr: "language.serbian",
    bg: "language.bulgarian"
};

export const normalizeSupportedLocale = (locale, fallback = "en") => {
    if (!locale || typeof locale !== "string") {
        return fallback;
    }
    const shortLocale = locale.trim().toLowerCase().split("-")[0];
    return SUPPORTED_LOCALES.includes(shortLocale) ? shortLocale : fallback;
};

/** Compare two locale strings after normalization (e.g. "en-US" vs "en"). */
export const localesNormalizedEqual = (a, b) =>
    normalizeSupportedLocale(a || "", "en") === normalizeSupportedLocale(b || "", "en");
